module.exports = __webpack_public_path__ + "img/referral.75e43452.svg";